export default googleActiveToken => {
  /* eslint-disable */
  !function (w, b, e, v, n, t, s) {
    w.dataLayer = w.dataLayer || [];
    if (w.gtag) return; n = w.gtag = function gtag(){
      dataLayer.push(arguments);
    }
    t = b.createElement(e); t.async = !0;
    t.src = v; s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s)
  }(window, document, 'script',
    `https://www.googletagmanager.com/gtag/js?id=${googleActiveToken}`);
  /* eslint-enable */
}
